import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

// component
import {LangController} from "../../../components/tabs/langController";

// labels
import { FL_IMAGE, FL_LONG_DESCRIPTION, FL_TITLE} from "../../../components/i18n/formLabels";


const SectionLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang.showOrder },
            title: '',
            image: '',
            longDescription: '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md={"8"}>
                <FormGroup>
                    <Label>{FL_TITLE}</Label>
                    <Input
                        type="textarea"
                        name="title"
                        rows="1"
                        value= { child.title }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"4"}>
                <FormGroup>
                    <Label>{FL_IMAGE}</Label>
                    <Input
                        type="text"
                        name="image"
                        value= { child.image }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label>{FL_LONG_DESCRIPTION}</Label>
                    <Input
                        type="textarea"
                        name="longDescription"
                        rows="5"
                        value= { child.longDescription }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return <LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default SectionLangs